



































































import { Component, Vue } from "vue-property-decorator";
import { configuration } from "@/config/host.config";
import { IPageConfig } from "@/@types/filoxenia-config/nav-bar";
import { deleteElement } from "@/api/delite/delite-element";

import AddRouteForm from "./route-nav/add-route-form.vue";
import RouteButtonCard from "./route-nav/route-button-card.vue";
import LowRouteButtonCards from "./route-nav/low-route-button-cards.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import RouteSvgIconsModal from "./route-nav/route-svg-icons-modal.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    AddRouteForm,
    RouteButtonCard,
    LowRouteButtonCards,
    InputSearch,
    RouteSvgIconsModal,
  },
})
export default class RoutesNavConfig extends Vue {
  routes: Array<IPageConfig> = [];
  route_id = "";
  search = "";

  get route(): IPageConfig | null {
    const route = this.routes.find((el) => el._id == this.route_id);
    return route ? route : null;
  }

  get routeList(): Array<IPageConfig> {
    return this.routes.filter((item: IPageConfig) => {
      return (
        this.$getLocale(item.name)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) > -1
      );
    });
  }

  mustChange(id: string): void {
    if (!this.$getRootPermition()) return;
    this.route_id = id;
    this.$nextTick(() => this.$bvModal.show("root-setting-routes-change"));
  }

  isError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  saweSortOrders(): void {
    for (let i = 0; i < this.routes.length; i++) {
      if (this.routes[i].sort_order != i)
        this.updateRoute({ sort_order: i }, this.routes[i]._id);
    }
  }

  async dropRoutes(): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("Settings.routes.buttons.drop")),
        }
      );

      if (result === true) {
        this.routes.forEach((el) => {
          this.deleteRoute(el._id);
        });
      }
    } catch {
      this.isError();
    }
  }

  deleteRoute(id: string): void {
    deleteElement(id, configuration.pages.force)
      .then(() => {
        const i = this.routes.findIndex((el) => el._id == id);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        if (i < 0) return this.createNavList();
        else this.routes.splice(i, 1);
      })
      .catch(() => {
        this.isError();
      });
  }

  async createNavList(): Promise<void> {
    const uri = configuration.pages.main;
    try {
      const res = await this.$axios.get(uri);
      if (res.status === 200 && this.$getRootPermition())
        this.routes = res.data;
    } catch (e) {
      console.log("create n av list error");
      console.error(e);
    }
  }

  async updateRoute(data: Partial<IPageConfig>, id: string): Promise<void> {
    const uri = id
      ? configuration.pages.main + "/" + id
      : configuration.pages.main;
    const method = id ? "put" : "post";

    try {
      const res = await this.$axios[method](uri, data);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        if (!id) this.routes.unshift(res.data);
        else {
          const i = this.routes.findIndex((el) => el._id == id);
          if (i < 0) return this.createNavList();
          this.$set(this.routes, i, res.data);
        }
        this.route_id = "";
      }
    } catch (e) {
      console.error(e);
      this.isError();
    }
  }

  mounted(): void {
    this.createNavList();
  }
}
